"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductApi = exports.ProductApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
// @ts-ignore
const models_3 = require("../models");
/**
 * ProductApi - axios parameter creator
 * @export
 */
const ProductApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ProductCreate} productCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct: async (productCreate, options = {}) => {
            // verify required parameter 'productCreate' is not null or undefined
            (0, common_1.assertParamExists)('addProduct', 'productCreate', productCreate);
            const localVarPath = `/api/product/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productCreate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (productId, options = {}) => {
            // verify required parameter 'productId' is not null or undefined
            (0, common_1.assertParamExists)('getProduct', 'productId', productId);
            const localVarPath = `/api/product/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IProductSearchEntity} iProductSearchEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: async (iProductSearchEntity, options = {}) => {
            // verify required parameter 'iProductSearchEntity' is not null or undefined
            (0, common_1.assertParamExists)('listProducts', 'iProductSearchEntity', iProductSearchEntity);
            const localVarPath = `/api/product/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iProductSearchEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ProductAttributes} productAttributes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (productAttributes, options = {}) => {
            // verify required parameter 'productAttributes' is not null or undefined
            (0, common_1.assertParamExists)('updateProduct', 'productAttributes', productAttributes);
            const localVarPath = `/api/product/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productAttributes, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ProductApiAxiosParamCreator = ProductApiAxiosParamCreator;
/**
 * ProductApi -
 */
var ProductApi;
(function (ProductApi) {
    /**
     *
     * @param {ProductCreate} productCreate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ProductApi
     * url /api/product/add
     */
    async function addProduct(productCreate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ProductApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.addProduct(productCreate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseProductAttributes)(res.data);
            return res;
        });
    }
    ProductApi.addProduct = addProduct;
    /**
     *
     * @param {number} productId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ProductApi
     * url /api/product/get
     */
    async function getProduct(productId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ProductApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getProduct(productId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseIProductEntity)(res.data);
            return res;
        });
    }
    ProductApi.getProduct = getProduct;
    /**
     *
     * @param {IProductSearchEntity} iProductSearchEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ProductApi
     * url /api/product/list
     */
    async function listProducts(iProductSearchEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ProductApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listProducts(iProductSearchEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseInlineResponse20013)(res.data);
            return res;
        });
    }
    ProductApi.listProducts = listProducts;
    /**
     *
     * @param {ProductAttributes} productAttributes
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ProductApi
     * url /api/product/update
     */
    async function updateProduct(productAttributes, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ProductApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(productAttributes, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseProductAttributes)(res.data);
            return res;
        });
    }
    ProductApi.updateProduct = updateProduct;
})(ProductApi || (exports.ProductApi = ProductApi = {}));
